export default __webpack_public_path__ + "static/media/profile.a3f00cf1.svg";